import 'components/orderSummary/components/orderTotals/discountLineItems.scss';
import { PromoCodeLineItem } from './promoCodeLineItem';
import template from './discountLineItems.html';

export const DiscountLineItems = angular
    .module('checkout.components.volt.orderSummary.discountLineItems', [
        PromoCodeLineItem
    ]).component('voltDiscountLineItems', {
        template,
        bindings: {
            discounts: '<',
            appliedDiscount: '<',
            onRemovePromoClicked: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/newCheckout/components/orderSummary/components/discountLineItems/discountLineItems.js